module.exports = __webpack_public_path__ + "img/chat.3f2f1355.svg";